// extracted by mini-css-extract-plugin
module.exports = {"container":"Avatar_container__fQpf4","img":"Avatar_img__9sg0P","edit":"Avatar_edit__31hgJ"};